import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RCSlider from 'rc-slider';
import bowser from 'yola-bowser';
import noop from '../utils/noop';
import useGrabbingCursor from './hooks/use-grabbing-cursor';
import constants from './constants';
import setNodeTransformScale from './helpers/set-node-transform-scale';

const { SLIDER_HANDLE_SELECTOR } = constants;

const { createSliderWithTooltip } = RCSlider;
const RCSliderWithTooltip = createSliderWithTooltip(RCSlider);

function handleTouchStart() {
  const sliderHandle = document.querySelector(SLIDER_HANDLE_SELECTOR);
  setNodeTransformScale(sliderHandle, 1.3);
}

function handleTouchEnd() {
  const sliderHandle = document.querySelector(SLIDER_HANDLE_SELECTOR);
  setNodeTransformScale(sliderHandle, 1);
}

function Slider({
  className = '',
  tooltipEnabled = false,
  onBeforeChange = noop,
  onAfterChange = noop,
  ...otherProps
}) {
  const isValueUnset = otherProps.value !== 0 && !otherProps.value;
  const classes = classnames(`ws-slider`, className);
  const tooltipPrefixCls = classnames(
    { 'ws-slider-tooltip--unset': isValueUnset },
    'ws-slider-tooltip',
    'rc-slider-tooltip'
  );
  const tooltipProps = {
    placement: 'top',
    prefixCls: tooltipPrefixCls,
  };
  const isMobile = bowser.mobile || bowser.tablet;

  if (isMobile) {
    otherProps.onBeforeChange = (value) => {
      onBeforeChange(value);
      handleTouchStart();
    };

    otherProps.onAfterChange = (value) => {
      onAfterChange(value);
      handleTouchEnd();
    };
  }

  useGrabbingCursor();

  return (
    <React.Fragment>
      {tooltipEnabled && (
        <RCSliderWithTooltip
          className={classes}
          tipProps={tooltipProps}
          onBeforeChange={onBeforeChange}
          onAfterChange={onAfterChange}
          {...otherProps}
        />
      )}
      {!tooltipEnabled && (
        <RCSlider
          className={classes}
          onBeforeChange={onBeforeChange}
          onAfterChange={onAfterChange}
          {...otherProps}
        />
      )}
    </React.Fragment>
  );
}

Slider.propTypes = {
  className: PropTypes.string,
  tooltipEnabled: PropTypes.bool,
  onBeforeChange: PropTypes.func,
  onAfterChange: PropTypes.func,
};

export default Slider;
